import _defineProperty from "/app/node_modules/.pnpm/next@13.5.3_@babel+core@7.14.3_@opentelemetry+api@1.4.1_react-dom@18.2.0_react@18.2.0_sass@1.49.9/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import axios from 'axios';
import { serverSide } from 'libs/utils/environment';
import { getLocale, logWarning, navigateToPage } from 'libs/utils/window';
import { REFRESH_ACCESS_TOKEN_API_ENDPOINT } from 'constants/paths';
import { HttpStatus, ResponseCode } from 'data/api/response-codes';
import { PHONE_VERIFICATION_URL } from 'constants/routes';
import { TWO_FA_CANCELLED_EVENT, TWO_FA_COMPLETED_EVENT } from 'constants/index';
export const railsCsrfTokenInterceptor = instance => instance.interceptors.request.use(config => {
  if (serverSide) return config;
  const csrfMeta = document.querySelector('meta[name="csrf-token"]');
  if (!csrfMeta) return config;

  const headers = _objectSpread(_objectSpread({}, config.headers), {}, {
    'X-CSRF-Token': csrfMeta.getAttribute('content')
  });

  return _objectSpread(_objectSpread({}, config), {}, {
    headers
  });
});
export const nextJsCsrfTokenInterceptor = instance => instance.interceptors.request.use(config => {
  const csrfToken = process.env.NEXT_PUBLIC_CSRF_TOKEN;
  if (!csrfToken) throw new Error('Missing Next.js CSRF token');

  const headers = _objectSpread(_objectSpread({}, config.headers), {}, {
    'X-CSRF-Token': csrfToken
  });

  return _objectSpread(_objectSpread({}, config), {}, {
    headers
  });
});
export const csrfTokenInterceptor = process.env.NEXT_PUBLIC_NEXT_JS === 'true' ? nextJsCsrfTokenInterceptor : railsCsrfTokenInterceptor;
export const tokenRefreshInterceptor = instance => instance.interceptors.response.use(undefined, error => {
  if (error.config && error.response && error.response.status === HttpStatus.Unauthorized) {
    return axios.post(REFRESH_ACCESS_TOKEN_API_ENDPOINT).then(() => instance.request(error.config));
  }

  return Promise.reject(error);
});
export const errorInterceptor = instance => instance.interceptors.response.use(response => {
  if (typeof response.data.code === 'undefined') {
    logWarning( // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
    "API code is missing in response: ".concat(response.request.responseURL, " with status: ").concat(response.status));
  }

  if (response.data.code && response.data.code !== ResponseCode.Ok) {
    // eslint-disable-next-line prefer-promise-reject-errors
    return Promise.reject({
      response
    });
  }

  return Promise.resolve(response);
});
export const localeInterceptor = instance => instance.interceptors.request.use(config => {
  var _document$querySelect;

  let locale = (_document$querySelect = document.querySelector('meta[name="accept-language"]')) === null || _document$querySelect === void 0 ? void 0 : _document$querySelect.getAttribute('content');
  if (!locale) locale = getLocale();

  if (!locale) {
    logWarning('Unable to retrieve locale for API call');
    return config;
  }

  return _objectSpread(_objectSpread({}, config), {}, {
    headers: _objectSpread(_objectSpread({}, config.headers), {}, {
      'Accept-Language': locale
    })
  });
});
export const phoneVerificationInterceptor = instance => instance.interceptors.response.use(undefined, error => {
  const {
    response
  } = error;

  if ((response === null || response === void 0 ? void 0 : response.data.code) === ResponseCode.UserVerificationRequired) {
    navigateToPage(PHONE_VERIFICATION_URL);
  }

  return Promise.reject(error);
});
export const twoFAInterceptor = instance => instance.interceptors.response.use(undefined, error => {
  const {
    response
  } = error;

  if ((response === null || response === void 0 ? void 0 : response.data.code) !== ResponseCode.TwoFARequired) {
    return Promise.reject(error);
  }

  const event = new CustomEvent('twoFARequired', {
    detail: response.data.payload.entity_id
  });
  window.dispatchEvent(event);
  return new Promise((resolve, reject) => {
    window.addEventListener(TWO_FA_COMPLETED_EVENT, () => {
      instance.request(response.config).then(resolve).catch(reject);
    });
    window.addEventListener(TWO_FA_CANCELLED_EVENT, () => {
      reject(error);
    });
  });
});